import { useState, useEffect } from 'react';
import DisplayDesk from '@assets/images/display.png';
import DisplayMob from '@assets/images/ImgFinal_Segmentações02.png';
import {
  SectionWrapper,
  StyledHr,
  ContentWrapper,
  ImageBox,
  TextBox1,
  TextBox2,
  SectionContainer,
} from './SegmentationFour.style';
import { useTranslation } from 'react-i18next';

const SegmentationFour = () => {
  const { t } = useTranslation('segmentation');
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <SectionContainer>
      <SectionWrapper>
        <h1>{t('segmentationFour.title')}</h1>
        <StyledHr />
      </SectionWrapper>

      <ContentWrapper>
        <TextBox1>
          <p className="first-paragraph">{t('segmentationFour.subtitle')}</p>

          {isMobile && (
            <ImageBox>
              <img src={DisplayMob} alt="Imagem Mobile" />
            </ImageBox>
          )}

          <p>{t('segmentationFour.paragraphOne.title')}</p>
          <TextBox2>
            <p>
              {t('segmentationFour.paragraphOne.spanBefore')} "
              <span>{t('segmentationFour.paragraphOne.span')}</span>"
            </p>
          </TextBox2>
          <p>{t('segmentationFour.paragraphTwo.title')}</p>
          <TextBox2>
            <p>
              {t('segmentationFour.paragraphTwo.spanBefore')} “
              <span>{t('segmentationFour.paragraphTwo.spanOne')}</span>”, “
              <span>{t('segmentationFour.paragraphTwo.spanTwo')}</span>”, “
              <span>{t('segmentationFour.paragraphTwo.spanThree')}</span>”,
              {t('segmentationFour.paragraphTwo.spanAfter')}
            </p>
          </TextBox2>
          <p>{t('segmentationFour.paragraphThree.title')}</p>
          <TextBox2>
            <p>{t('segmentationFour.paragraphThree.paragraph')}</p>
          </TextBox2>
        </TextBox1>

        {!isMobile && (
          <ImageBox>
            <img src={DisplayDesk} alt="Imagem Desktop" />
          </ImageBox>
        )}
      </ContentWrapper>
    </SectionContainer>
  );
};

export default SegmentationFour;
